import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges } from '@angular/core';
import { DEFAULTS } from '@monsido/core/constants/defaults.constant';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface Collection {
    total?: number;
    length?: number;
}

@Component({
    selector: 'table-container-pager',
    templateUrl: './table-container-pager.component.html',
    standalone: false,
})
export class TableContainerPagerComponent implements OnInit, OnDestroy, OnChanges {
    @Input() collection: Collection | any[] = [];
    @Input() progress: Promise<any> | boolean = false;
    @Input() noResultMessage: string = 'No content was found';
    @Input() pageSize?: any = DEFAULTS.API.PAGE_SIZE;
    @Input() page: number = 1;

    @Output() onPageChange = new EventEmitter<number>();
    @Output() onPerPageChange = new EventEmitter<number>();

    showTable: boolean = true;
    showProgress: boolean = false;
    private destroy$ = new Subject<void>();
    private progressSubject$ = new BehaviorSubject<Promise<any> | boolean>(false);

    constructor () {
    }

    ngOnInit (): void {
        this.showTable = true;
        this.showProgress = false;
        this.progress = this.progress || false;
        this.collection = this.collection || [];
        this.noResultMessage = this.noResultMessage || 'No content was found';

        this.progressSubject$.pipe(
            takeUntil(this.destroy$),
        ).subscribe(() => {
            this.isProgressRunning();
        });

        this.progressSubject$.next(this.progress);
    }

    ngOnChanges (change) {
        this.isProgressRunning();
    }

    ngOnDestroy (): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    showPagination (): boolean {
        return Number(this.collection ? (this.collection as Collection).total : 0) > this.getPageSize();
    }

    getPageSize (): number {
        let pageSize = DEFAULTS.API.PAGE_SIZE;
        if (typeof this.pageSize !== 'undefined' && !isNaN(parseInt(String(this.pageSize), 10))) {
            pageSize = parseInt(String(this.pageSize), 10);
        }

        return Number(pageSize);
    }

    pageChange (page: number): void {
        this.onPageChange.emit(page);
    }

    noPrevious (): boolean {
        if (!Array.isArray(this.collection)) {
            return true;
        }
        return this.page <= 1;
    }

    noNext (): boolean {
        if (!Array.isArray(this.collection)) {
            return true;
        }
        return this.collection.length < (this.pageSize || DEFAULTS.API.PAGE_SIZE);
    }

    numPages (): number {
        return 0;
    }

    private isProgressRunning (): void {
        this.showProgress = true;
        this.showTable = false;

        Promise.resolve(this.progress).finally(() => {
            setTimeout(() => {
                this.showProgress = false;
                this.showTable = Boolean(this.collection && (this.collection as any[]).length > 0);
            });
        });
    }

    handlePerPageChange (event: string): void {
        this.onPerPageChange.emit(parseInt(event, 10));
    }
}
